export default "__VITE_ASSET__uCKNYfSG__"